import { createFileRoute } from '@tanstack/react-router'
import GtmRunPage from '@/pages/gtm-run'

// A demo run's stage chain. Public (no signup), not indexed or prerendered.
export const Route = createFileRoute('/$lang/gtm/$runId')({
  validateSearch: (search: Record<string, unknown>) => ({
    checkout:
      typeof search.checkout === 'string' &&
      (search.checkout === '1' ||
        /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
          search.checkout,
        ))
        ? search.checkout
        : undefined,
  }),
  component: GtmRunPage,
  staticData: { layout: 'public' },
})
